module.exports = __webpack_public_path__ + "img/mobile_map_lima.cbd8733c.svg";